import { render, staticRenderFns } from "./ViewResumeHistorical.vue?vue&type=template&id=20007cd8"
import script from "./ViewResumeHistorical.vue?vue&type=script&lang=js"
export * from "./ViewResumeHistorical.vue?vue&type=script&lang=js"
import style0 from "./ViewResumeHistorical.vue?vue&type=style&index=0&id=20007cd8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports